import { render, staticRenderFns } from "./advertisementConfig.vue?vue&type=template&id=f4b7101a&scoped=true"
import script from "./advertisementConfig.vue?vue&type=script&lang=js"
export * from "./advertisementConfig.vue?vue&type=script&lang=js"
import style0 from "./advertisementConfig.vue?vue&type=style&index=0&id=f4b7101a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b7101a",
  null
  
)

export default component.exports